import type { AuthState, GetterClass } from '../../../models'

export class KeepLoggedInGetter implements GetterClass {
  static execute(this: void, state: AuthState): boolean {
    return state.keepLoggedIn
  }
}
